export const HOME_URL = '/home'
export const SIGNIN_URL = '/signin'
